import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
export const MEMBER_NOTICE_KINDS=['original-welcome','free-granted','revoked','trial-granted','trial-ended','paid-welcome'];
export function unreadMemberNotice(value) {
  const paidValid=value?.kind!=='paid-welcome'||value.paymentConfirmed===true&&Number.isSafeInteger(value.paidThroughAt)&&value.paidThroughAt>Date.now();
  return value && typeof value.id==='string' && value.id.length<=200 && MEMBER_NOTICE_KINDS.includes(value.kind) && value.seenAt==null && paidValid ? value : null;
}
// Compare the notice inside the transaction: closing an old notice cannot mark
// a newer grant or revocation as read if the owner changes it at the same time.
export async function acknowledgeMemberNotice(db,uid,id,transact=runTransaction) {
  const ref=doc(db,'users',uid,'membershipNotices','current');
  return transact(db,async tx=>{const saved=await tx.get(ref);if(saved.exists()&&saved.data().id===id&&saved.data().seenAt==null)tx.update(ref,{seenAt:serverTimestamp()});});
}
